<template>

    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>个人设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 搜索筛选 -->
        <el-card class="filter-container" style="margin-bottom: 20px;">
            <el-form class="user-search" label-width="80px">
                <el-form-item label="昵称">
                    <el-input v-model="userData.name" class="input-width" :disabled="disabled"></el-input>

                </el-form-item>
                <el-form-item label="用户名">
                    <el-input v-model="userData.username" class="input-width" :disabled="true"></el-input>

                  </el-form-item>

                <el-form-item label="手机号码">
                    <el-input v-model="userData.phone" class="input-width" :disabled="disabled"></el-input>

                </el-form-item>
                <el-form-item label="角色">
                    <el-input v-model="userData.userRoles" class="input-width" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="5" placeholder="请输入内容"  class="input-width" :disabled="disabled"/>
                </el-form-item>
                <div v-if="disabled">
                    <!-- changeUserInfo -->
                    <el-button size="small" @click="setting">修改资料</el-button>
                    <el-button size="small" @click="Visible=true">修改密码</el-button>
                    <el-button size="small" @click="forgetPs">忘记密码</el-button>

                </div>
                <div v-else>
                    <el-button size="small" @click="changeUserInfo">修改</el-button>
                    <el-button size="small" @click="disabled=true">取消</el-button>
                </div>

            </el-form>
        </el-card>


        <el-dialog :close-on-click-modal="false" title="查看详情" :visible.sync="Visible" width="40%"
            @click="closeDialog" center>
            <el-form class="user-search" label-width="80px">

                <el-form-item label="用户名">
                    <el-input v-model="userData.username" class="input-width" ></el-input>

                  </el-form-item>
                  <el-form-item label="原密码">
                    <el-input v-model="userData.password" class="input-width" ></el-input>

                </el-form-item>
                <el-form-item label="新密码">
                    <el-input v-model="userData.newPassword" class="input-width" ></el-input>

                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">返回</el-button>
                <el-button size="small" @click="changePs">修改</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    import {modifyPassword} from '@/api/basisMG'
    // 导出模块
    export default {
       
        data() {
            //数据
            return {
                time1: [],
                disabled:true,
                loading: true,
                Visible: false,

                formInline: {
                    start: 0,
                    length: 5,

                },
                listData: [],
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 5,
                    total: 10,
                    start: 0,
                    length: 5
                },
                userData:{}
            };
        },


        watch: {},

        methods: {
            forgetPs(){},

            setting(){
                this.disabled = false
            },
          
            changePs(){
              let param = {}
              param.oldPassword = this.userData.password
              param.newPassword = this.userData.newPassword
              modifyPassword(param).then(res=>{
                console.log(res.data)
                this.$message({
                    type: 'success',
                    message: '修改成功，请重新登录!'
                })
                setTimeout(() => {
                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                        type: 'success',
                        message: '修改成功，请重新登录!'
                    })
                }, 2000)
              })
            },
            changeUserInfo(){},
            changetime1(val) {
                if (val.length) {
                    this.formInline.sendTimeStart = val[0]
                    this.formInline.sendTimeEnd = val[1]
                } else {
                    this.formInline.sendTimeStart = ""
                    this.formInline.sendTimeEnd = ""
                }
            },

            closeDialog() {
                this.Visible = false
            },
            // 获得商品数据
            getdata() {
              

                // getExperienceOrderList(param).then(res => {
                //     if (res.code == '200') {
                //         this.listData = res.data.content
                //         this.loading = false
                //         this.pageparm.total = res.data.totalElements
                //     }
                // })
            },


            // 查询
            search() {
				
                this.getdata(this.formInline)
            },
            // 清空
            clear() {
                this.formInline = {
                    start: 0,
                    length: 10,

                }
                this.getdata(this.formInline)
            },

            // 分页插件事件
            callFather(parm) {
                this.pageparm.currentPage = parm.currentPage
                this.pageparm.pageSize = parm.pageSize
                this.pageparm.start = parm.currentPage - 1
                this.pageparm.length = parm.pageSize
                this.formInline.start = parm.currentPage - 1
                this.formInline.length = parm.pageSize
                this.getdata(this.formInline)
            },
            addFun() { },
            submitFun() { }
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getParams(this.$route.path)
            this.userData = JSON.parse(sessionStorage.getItem('userdata'))
            console.log(this.userData)
            this.getdata()
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style scoped>
.input-width{
    width: 350px;
}
</style>
